var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Spin',{attrs:{"fix":""}},[_c('Icon',{staticClass:"demo-spin-icon-load",attrs:{"type":"ios-loading","size":"40"}}),_c('p',{staticStyle:{"line-height":"40px"}},[_vm._v("正在获取用户信息，请稍后....")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }